export const handlerFillSelector = (recordset) => {
  return recordset?.map((values) => {
    return {
      label:values.name,
      value:values.id,
      ...values
    }
  })
} 